import { useQuery } from "@tanstack/react-query";
import {
  checkServicePrice,
  NO_LIMITS,
  type ServicePriceLimits,
} from "@/lib/service-price-limits-shared";

export function useServicePriceLimits(): ServicePriceLimits {
  const { data } = useQuery({
    queryKey: ["service-price-limits"],
    queryFn: async () => {
      const res = await fetch("/api/service-price-limits");
      if (!res.ok) return NO_LIMITS;
      return (await res.json()) as ServicePriceLimits;
    },
    staleTime: 5 * 60 * 1000,
  });
  return data ?? NO_LIMITS;
}

/**
 * Error message for a price the user is editing, or null when it may be saved.
 * `savedPrice` is the price already stored on the service: leaving it untouched is
 * always allowed, matching the server's grandfathering rule.
 */
export function useServicePriceError(
  price: number | null,
  savedPrice?: number | null,
): string | null {
  const limits = useServicePriceLimits();
  if (price === null) return null;
  if (savedPrice !== null && savedPrice !== undefined && price === savedPrice) return null;
  return checkServicePrice(price, limits);
}
